import { type ProductConfig, PRODUCT_CATALOG, ALL_PRODUCTS } from "./products";
import {
  getMetadataKeyFromUrlSlug,
  resolveCanonicalProductType,
} from "./resolution";

export function getAllProducts(): readonly ProductConfig[] {
  return ALL_PRODUCTS;
}

function getProductByUrlSlug(urlSlug: string): ProductConfig | undefined {
  const metadataKey = getMetadataKeyFromUrlSlug(urlSlug);
  if (metadataKey) {
    return PRODUCT_CATALOG[metadataKey];
  }
  return undefined;
}

export function getProductDisplayNameFromUrlSlug(
  urlSlug: string,
): string | null {
  const product = getProductByUrlSlug(urlSlug);
  return product?.name ?? null;
}

export function getProductSingularNameFromUrlSlug(
  urlSlug: string,
): string | null {
  const product = getProductByUrlSlug(urlSlug);
  if (!product) return null;
  return product.singularName ?? product.name ?? null;
}

export function getProductSingularName(value: string): string | null {
  if (typeof value !== "string") return null;
  const normalized = value.trim();
  if (!normalized) return null;

  const resolution = resolveCanonicalProductType(value);
  if (resolution.canonicalSlug) {
    const product = PRODUCT_CATALOG[resolution.canonicalSlug];
    if (product) {
      return product.singularName ?? product.name ?? null;
    }
  }

  const product = getProductByUrlSlug(normalized);
  if (product) {
    return product.singularName ?? product.name ?? null;
  }

  return null;
}
